import React from 'react';
import { Country } from 'App/i18n/enums';
import { useCountry } from 'commons/hooks';

type RenderByCountryProps = Partial<Record<Country, React.ReactNode>>;

function RenderByCountry({ ...countries }: RenderByCountryProps) {
  const { storeCountry } = useCountry();

  if (!countries[storeCountry]) {
    return null;
  }

  return <>{countries[storeCountry]}</>;
}

export default RenderByCountry;
